<template>
  <div>
    <div class="BtnArea" v-show="isPortalOpen">
      <div
        class="button"
        @mouseover="redoSrc = redoHover"
        @mouseout="redoSrc = redo"
        @click="eventEmit('redo')"
      >
        <img :src="redoSrc" />
      </div>
      <div
        class="button"
        @mouseover="undoSrc = undoHover"
        @mouseout="undoSrc = undo"
        @click="eventEmit('undo')"
      >
        <img :src="undoSrc" />
      </div>
      <div
        class="button"
        @click="eventEmit('zoomin')"
        @mouseover="zoomInSrc = zoominHover"
        @mouseout="zoomInSrc = zoomin"
      >
        <img :src="zoomInSrc" />
      </div>
      <div
        class="button"
        @click="eventEmit('zoomout')"
        @mouseover="zoomOutSrc = zoomoutHover"
        @mouseout="zoomOutSrc = zoomout"
      >
        <img :src="zoomOutSrc" />
      </div>
    </div>
    <div class="toggleBtn" @click="togglePortal">
      <img
        :src="
          require(`@/assets/icon/${isPortalOpen ? 'icChartControlOn' : 'icChartControlOff'}.png`)
        "
        alt=""
      />
    </div>
  </div>
</template>

<script>
import zoomin from '@/assets/icon/icChartControlZoomIn.png';
import zoominHover from '@/assets/icon/icChartControlZoomInBlue.png';
import zoomout from '@/assets/icon/icChartControlZoomOut.png';
import zoomoutHover from '@/assets/icon/icChartControlZoomOutBlue.png';
import undo from '@/assets/icon/icChartControlUndo.png';
import undoHover from '@/assets/icon/icChartControlUndoBlue.png';
import redo from '@/assets/icon/icChartControlRedo.png';
import redoHover from '@/assets/icon/icChartControlRedoBlue.png';

export default {
  data() {
    return {
      isPortalOpen: false,
      zoomInSrc: zoomin,
      zoomOutSrc: zoomout,
      undoSrc: undo,
      redoSrc: redo,
      zoomin,
      zoominHover,
      zoomout,
      zoomoutHover,
      undo,
      undoHover,
      redo,
      redoHover,
    };
  },
  methods: {
    togglePortal() {
      this.isPortalOpen = !this.isPortalOpen;
    },
    eventEmit(e) {
      this.$emit(e);
    },
  },
};
</script>

<style lang="scss" scoped>
.toggleBtn {
  width: 79px;
  height: 35px;
  border-radius: 10px 10px 0 0;
  background-color: #23b6bc;
  display: flex;
  cursor: pointer;
  img {
    height: 16px;
    width: 27px;
    margin: auto;
  }
}
.BtnArea {
  width: 100%;
  .button {
    img {
      width: 45px;
    }
    margin-bottom: 12px;
    cursor: pointer;
  }
}
</style>
